import Image from "next/image";

interface ImageBannerProps {
  src: string;
  alt: string;
  className?: string;
}

export default function ImageBanner({
  src,
  alt,
  className = "",
}: ImageBannerProps) {
  return (
    <div className={className}>
      <div className="w-full aspect-[10/13] md:aspect-[5/4] lg:aspect-[8/5] xl:aspect-[13/8] 2xl:aspect-[15/8] relative max-w-[1440px] mx-auto">
        <Image
          className="rounded-3xl object-cover"
          src={src}
          alt={alt}
          fill
          objectFit="cover"
        />
      </div>
    </div>
  );
}
